import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react"; //Limitless imports

import { log as pilog } from "../../utils";
import * as WSClient from "../../utils/paho-mqtt";
import { getWebSocketURL } from "../../apis";
window.Paho = {
  MQTT: WSClient
}; //the above is why JavaScript is the worst. A polyfill to help the terrible paho-mqtt not self-destruct.

var client = null;
var isConnected = false;
export var useWebSocketsHook = function useWebSocketsHook(eventProcessorHook, profile) {
  var log = pilog.getLogger("useWebSocketsHooks");

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      events = _React$useState2[0],
      setEvents = _React$useState2[1];

  var _eventProcessorHook = eventProcessorHook(profile),
      onConnect = _eventProcessorHook.onConnect,
      onDisconnect = _eventProcessorHook.onDisconnect,
      processWebSocketEvent = _eventProcessorHook.processWebSocketEvent,
      rest = _objectWithoutProperties(_eventProcessorHook, ["onConnect", "onDisconnect", "processWebSocketEvent"]);

  React.useEffect(function () {
    if (events.length !== 0) {
      events.map(function (event) {
        processWebSocketEvent(event);
      });
    }
  }, [events]);

  var connectToWebSocket = function connectToWebSocket() {
    if (process.env.REACT_APP_WS_HISTORY) {
      window.wsEvents = [];
      window.wsEventsRejected = [];
    }

    if (!isConnected) {
      getWebSocketURL(function (url) {
        log.debug("Initialising WebSocket Connection");
        client = new WSClient.Client(url, Math.floor((100000000 + Math.random()) * 900000000).toString());

        client.onConnected = function (isReconnect) {
          log.debug("Successfully connected to Web Sockets");
          onConnect(client, isReconnect);
          isConnected = true;
        };

        client.onConnectionLost = function (reason) {
          log.info("WebSocket Connection Lost!.. ", reason);
          isConnected = false;
        };

        client.onMessageArrived = function (message) {
          try {
            var event = JSON.parse(message.payloadString);
            event.topic = message.destinationName;
            log.debug("Event Arrived!", event);
            setEvents([].concat(_toConsumableArray(events), [event]));
          } catch (error) {
            log.error("Failed to process web socket event %o", error);
          }
        };

        client.connect({
          reconnect: true,
          reconnectInterval: 10,
          getReconnectURL: getWebSocketURL,
          //heartbeat is default to 60 seconds
          keepAliveInterval: process.env.REACT_APP_WS_HEARTBEAT ? Number(process.env.REACT_APP_WS_HEARTBEAT) : 60,
          onSuccess: function onSuccess() {
            log.info("Successfully connected to Realtime Endpoint!");
          },
          onFailure: function onFailure(error) {
            log.info("Failed to setup web sockets %o", error);
          }
        });
      }, function (error) {
        log.error("Failed to get secure web socket URL %o", error);
      });
    }
  };

  var disconnectFromWebSocket = function disconnectFromWebSocket() {
    if (client && isConnected) {
      onDisconnect(client);
    }
  }; // Make the context object:


  return _objectSpread({
    connectToWebSocket: connectToWebSocket,
    isConnected: isConnected,
    disconnectFromWebSocket: disconnectFromWebSocket
  }, rest);
};